import script from "./File.vue?vue&type=script&setup=true&lang=js"
export * from "./File.vue?vue&type=script&setup=true&lang=js"

import "./File.vue?vue&type=style&index=0&id=8917ccd4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8917ccd4"]])

export default __exports__